import { useEffect, useMemo, useState } from "react";
import { SnackbarOrigin, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

const useServiceWorkerWrapper = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const anchorOrigin = useMemo<SnackbarOrigin>(
    () => ({ vertical: "top", horizontal: "center" }),
    [],
  );
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
    null,
  );

  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: onSWUpdate });
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });
    setShowReload(false);
    window.location.reload();
  };

  return {
    styles,
    classes,
    anchorOrigin,
    t,
    atomicStyles,
    showReload,
    reloadPage,
  };
};

export { useServiceWorkerWrapper as default };
